import script from "./ServiceVendorInviteDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceVendorInviteDetail.vue?vue&type=script&setup=true&lang=js"

import "./ServiceVendorInviteDetail.vue?vue&type=style&index=0&id=485a465a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-485a465a"]])

export default __exports__